export default __webpack_public_path__ + "static/media/rocket_anim_109.07865bd2.png";